<div class="row" [ngClass]="{'ivr_suggest_display': frmCmms,'suggest_display': !frmCmms,'mb-3 has-error': focusOut && !frmCmms}">
    <div class="col input-group" [ngClass]="!frmCmms ? 'pe-0' : ''">
        <input 
        id="pharmacy-search" 
        type="text" 
        class="form-control"
        [ngClass]="!frmCmms ? 'height_325' : ''"
        [(ngModel)]="searchTerm"
         (blur)="!isFrmPatExternHist ? onInputBlur() : ''"
       (ngModelChange)="!isFrmPatExternHist || frmCmms ? onSearchInputChange($event) : null"
        [title]="''"
        [minLength]="3"
        (selectItem)="selectedPharmacyDetails($event.item)"
        placeholder="Enter Pharmacy Name or /Address - Min 3 Chars,  NPI or #Phone - 10 Chars"
        (keyup.enter)="isFrmPatExternHist ? triggerPharmacySearch($event.target.value) : enteredValue($event)" (keydown.tab)="isFrmPatExternHist ? triggerPharmacySearch($event.target.value) : enteredValue($event)" (change)= "isFrmPatExternHist ? triggerPharmacySearch($event.target.value) : enteredValue($event)" [disabled]="isDisabled ? true : false" [appAutofocus]="pharmFocus"/>
          <div class="search--icon" *ngIf="!isFrmPatExternHist">
            <i class="far fa-search" (click)="isDisabled ? '' : inputClearedBySearchIcon()"></i>
        </div> &nbsp;
        <i *ngIf="!isFrmPatExternHist && !frmCmms" class="fas fa-info-circle" style="line-height: 2"  tooltipClass="common-tooltip pharmacy-suggest-info-tooltip"  [ngbTooltip]="pharmacySuggestInfo" placement="bottom"></i>
      <span class="help-block pharmacy-error" *ngIf="focusOut && !frmCmms"> Required </span>
      </div>
      <div class="col-2 px-0" *ngIf="!isFrmPatExternHist && !frmCmms">
        <button aria-hidden="true" id="pharmAdd" [ngClass]="isDisabled ? 'inactive' : 'hotkey_success'" appTooltip="Add Pharmacy" (click)="isDisabled ? '' : openAddPopUp()" appShortcutKey [AltKey]="'a'"><span>A</span>ADD</button>
         </div>
      <div class="col-1 ps-0 patient-edit--transfer-in" *ngIf="!isFrmPatExternHist && !frmCmms && !TransferPharmacyDetails">
        <i class="fa-kit fa-pharmacy-icon" [ngClass]="selectedPharmDeatails ? (selectedPharmDeatails.ServiceLevels ? 'color_green' : (selectedPharmDeatails?.PharmName && !selectedPharmDeatails.ServiceLevels) ? 'unavailable' : '') : ''" 
        tooltipClass="pharmacy-tooltip common-tooltip" 
        [ngbTooltip]="selectedPharmDeatails ? (selectedPharmDeatails.ServiceLevels ? 'eRx Transfer Eligible' : 'eRx Transfer Ineligible') : 'Transfer Eligibility'" triggers="mouseover:mouseleave"
        [autoClose]="true" placement="left"></i> 
      </div>
         <div class="col-1 ps-0 patient-edit--transfer-in" *ngIf="TransferPharmacyDetails">
        <i class="fa-kit fa-pharmacy-icon" [ngClass]="TransferPharmacyDetails ? (TransferPharmacyDetails.isServiceEnabled ? 'color_green' : (TransferPharmacyDetails?.PharmName && !TransferPharmacyDetails.isServiceEnabled) ? 'unavailable' : '') : ''" 
        tooltipClass="pharmacy-tooltip common-tooltip" 
        [ngbTooltip]="TransferPharmacyDetails ? (TransferPharmacyDetails.isServiceEnabled ? 'eRx Transfer Eligible' : 'eRx Transfer Ineligible') : 'Transfer Eligibility'" triggers="mouseover:mouseleave"
        [autoClose]="true" placement="left"></i> 
      </div>
</div>

<div *ngIf="PharmacyNamesList?.length > 0 && isShowdropdown" class="suggestion-box">
    <div *ngFor="let x of PharmacyNamesList" class="suggestion-item" (click)="selectedPharmacyDetails(x)">
      <div class="row pharmacy-suggest">
      <div class="col-8 px-0 text-wrap">
            <label>Name</label>&nbsp;
            <span>{{ x?.PharmName ? (x?.PharmName | uppercase) :  msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 ">
            <label>NPI#</label>&nbsp;
            <span>{{x?.NPINum ? x?.NPINum : msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2">
            <label>Phone#</label>&nbsp;
            <span>{{x?.Phone ? this._commonUtil.getPhoneFormat(x?.Phone) : msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2">
            <label>Fax#</label>&nbsp;
            <span>{{(x?.Fax) ? this._commonUtil.getPhoneFormatForWrongFax(x?.Fax): msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2" *ngIf="IsFromeRxpage">
            <label>NCPDPID#</label>&nbsp;
            <span>{{(x?.NCPDPID) ? x?.NCPDPID : msgConfig.EMPTY_Data}}</span>
        </div>  
        <div class="ps-0 mt-2 text-wrap col-8">
            <label>Address</label>&nbsp;
            <span>{{ getPatientAddress(x) | uppercase }}</span>
        </div>
        <div class="col-4 px-0 mt-2">
            <label>XFER Service</label>&nbsp;
            <span [ngClass]= "checkService(x) ? 'color_green' : 'unavailable'">
              {{checkService(x) ? 'Available': 'Unavailable'}}</span>
        </div>
      </div>
    </div>
</div>

<ng-template #rt let-x="result">
    <div class="row pharmacy_suggest"  (click)="selectedPharmacyDetails(x)">
        <div class="col-8 px-0 text-wrap">
            <label>Name</label>&nbsp;
            <span>{{ x?.PharmName ? (x?.PharmName | uppercase) :  msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 ">
            <label>NPI#</label>&nbsp;
            <span>{{x?.NPINum ? x?.NPINum : msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2">
            <label>Phone#</label>&nbsp;
            <span>{{x?.Phone ? this._commonUtil.getPhoneFormat(x?.Phone) : msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2">
            <label>Fax#</label>&nbsp;
            <span>{{(x?.Fax) ? this._commonUtil.getPhoneFormatForWrongFax(x?.Fax): msgConfig.EMPTY_Data}}</span>
        </div>
        <div class="col-4 px-0 mt-2" *ngIf="IsFromeRxpage">
            <label>NCPDPID#</label>&nbsp;
            <span>{{(x?.NCPDPID) ? x?.NCPDPID : msgConfig.EMPTY_Data}}</span>
        </div>  
        <div class="ps-0 mt-2 text-wrap" [ngClass]="IsFrom ? 'col-12' : 'col-8'">
            <label>Address</label>&nbsp;
            <span>{{ getPatientAddress(x) | uppercase }}</span>
        </div>
        <div class="col-4 px-0 mt-2" *ngIf="!IsFrom">
            <label>XFER Service</label>&nbsp;
            <span [ngClass]= "checkService(x) ? 'color_green' : 'unavailable'">
              {{checkService(x) ? 'Available': 'Unavailable'}}</span>
        </div>
    </div>
   
  </ng-template>
  
  <ng-template #patExternPhamracySuggest let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">Pharmacy Search</h4>
      <button type="button" class="close" (click)="d('Cross click')">
        <span aria-hidden="true" class="close-button">&times;</span>
      </button>
    </div>
    <div class="modal-body edit-patient insurance--body">
      <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-8">
                    <label class="margin_left_0_8rem">Search</label>
                    <input
                        autofocus 
                        type="text" 
                        class="form-control search--input__box margin_left_10px" 
                        placeholder="Search Pharmacy"
                        [(ngModel)]="popupSearchTerm"
                        (keyup.enter)="searchPhamracy()"
                    />
                    <i class="fas fa-info-circle"  *ngIf="InformationTool" [ngbTooltip]="InformationTool" tooltipClass="common-tooltip"></i>
                </div>
                <div class="col-4 margin_top_1rem">
                    <button class="hotkey_success" (click)="searchPhamracy()" appShortcutKey 
                    [AltKey]="'f'"><span>F</span>Search
                </button>
                <button class="hotkey_success" (keydown.enter)="clearInputFiled()" (click)="clearInputFiled()"
                    appShortcutKey [AltKey]="'l'">
                    <span>L</span> Clear
                </button>
                </div>
            </div>
            <div *ngIf="PharmacyNamesList && PharmacyNamesList.length > 0; else noData" class="extern_search_result">
                <div *ngFor="let x of PharmacyNamesList">
                    <ng-container *ngTemplateOutlet="rt; context: { result: x }"></ng-container>
                </div>
              </div>
              <ng-template #noData>
                <app-no-data-found></app-no-data-found>
              </ng-template>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #pharmacySuggestInfo>
    <div tooltipClass="common-tooltip" placement="bottom" container="body">
      <br>
      You can search for a pharmacy using these formats:
      <br>
      <ul class="pharmacy-suggest-info-cont">
        <li><b>By Name:</b> Pharmacy Name (Min 3 Chars)</li>
        <li><b>By Address:</b> /Address (Min 3 Chars)<br>
        </li>
        <li><b>By Phone:</b> #Phone Number (Min 10 Chars)<br>
        </li>
        <li><b>By NPI:</b> Pharmacy NPI (Min 10 Chars)</li>
      </ul>
    </div>
  </ng-template>